// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  .v-validate-pristine--style, v-input-currency.v-validate-pristine.ng-invalid input.p-inputtext, v-input-currency.ng-invalid.ng-dirty input.p-inputtext, .v-formControl.v-validate-pristine .ng-invalid.v-component-container, .v-formControl.v-validate-pristine .ng-invalid.p-component,
  .v-formControl .ng-invalid.ng-dirty.v-component-container,
  .v-formControl .ng-invalid.ng-dirty.p-component {
    --dropdown-border: 1px solid var(--gc-color-danger);
    border-color: var(--gc-color-danger) !important;
    outline: solid 1px var(--gc-color-danger);
    outline-offset: -4px;
  }
  .v-required .v-component-label:after,
  .v-formControl.v-required .v-component-label:after {
    content: "*";
    margin-left: 0.25rem;
    color: var(--gc-color-danger);
  }
  .v-readonly, .v-readonly input {
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
  }
}
@layer vierkant {
  v-input-currency input {
    text-align: end;
    width: var(--input-number-width-full);
  }
  v-input-currency input.clear {
    padding-right: var(--input-number-clear-icon-padding-right) !important;
  }
  v-input-currency input.size-small {
    width: var(--input-number-width-small) !important;
  }
  v-input-currency input.size-medium {
    width: var(--input-number-width-medium) !important;
  }
  v-input-currency input.size-large {
    width: var(--input-number-width-large) !important;
  }
  v-input-currency .v-component-container {
    width: fit-content;
    display: flex;
    align-items: center;
    background: var(--input-number-background);
    border-radius: var(--input-number-border-radius);
  }
  v-input-currency .v-component-container.prefixed input {
    border-top-left-radius: var(--input-number-border-top-left-radius);
    border-bottom-left-radius: var(--input-number-border-bottom-left-radius);
  }
  v-input-currency .v-component-container.suffixed input {
    border-top-right-radius: var(--input-number-border-top-right-radius);
    border-bottom-right-radius: var(--input-number-border-bottom-right-radius);
  }
  v-input-currency .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }
  v-input-currency .affix {
    padding: var(--input-number-padding);
    text-wrap: nowrap;
    -webkit-user-select: none;
            user-select: none;
  }
  v-input-currency .clear-icon {
    position: absolute;
    right: 0.75rem;
    cursor: pointer;
    color: var(--gc-text-color-secondary, currentColor);
  }
  v-input-currency .clear-icon:hover {
    color: var(--gc-text-color, currentColor);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/validation.sass","webpack://./src/app/modules/wrappers/lib/input-currency/input-currency.component.sass"],"names":[],"mappings":"AAAA;EACI;;;IACI,mDAAA;IACA,+CAAA;IACA,yCAAA;IACA,oBAAA;ECGN;EDDE;;IAEI,YAAA;IACA,oBAAA;IACA,6BAAA;ECGN;EDGE;IACI,yBAAA;YAAA,iBAAA;IACA,oBAAA;ECDN;AACF;AAlBA;EAOQ;IACI,eAAA;IACA,qCAAA;EAcV;EAbU;IACI,sEAAA;EAed;EAbc;IACI,iDAAA;EAelB;EAdc;IACI,kDAAA;EAgBlB;EAfc;IACI,iDAAA;EAiBlB;EAfM;IACI,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,0CAAA;IACA,gDAAA;EAiBV;EAfc;IACI,kEAAA;IACA,wEAAA;EAiBlB;EAfc;IACI,oEAAA;IACA,0EAAA;EAiBlB;EAhBM;IACI,kBAAA;IACA,aAAA;IACA,mBAAA;EAkBV;EAjBM;IACI,oCAAA;IACA,iBAAA;IACA,yBAAA;YAAA,iBAAA;EAmBV;EAlBM;IACI,kBAAA;IACA,cAAA;IACA,eAAA;IACA,mDAAA;EAoBV;EAnBU;IACI,yCAAA;EAqBd;AACF","sourcesContent":["@layer vierkant\n    .v-validate-pristine--style\n        --dropdown-border: 1px solid var(--gc-color-danger)\n        border-color: var(--gc-color-danger) !important\n        outline: solid 1px var(--gc-color-danger)\n        outline-offset: -4px\n\n    .v-required .v-component-label:after,\n    .v-formControl.v-required .v-component-label:after\n        content: '*'\n        margin-left: 0.25rem\n        color: var(--gc-color-danger)\n    .v-formControl.v-validate-pristine .ng-invalid, \n    .v-formControl .ng-invalid.ng-dirty\n        &.v-component-container, &.p-component\n            @extend .v-validate-pristine--style    \n\n    .v-readonly, .v-readonly input\n        user-select: none\n        pointer-events: none","@use '../validation.sass'\n@layer vierkant\n    v-input-currency\n\n        &.v-validate-pristine.ng-invalid input.p-inputtext,\n        &.ng-invalid.ng-dirty input.p-inputtext\n            @extend .v-validate-pristine--style\n\n        input\n            text-align: end\n            width: var(--input-number-width-full)\n            &.clear\n                padding-right: var(--input-number-clear-icon-padding-right) !important\n            &.size-\n                &small\n                    width: var(--input-number-width-small) !important\n                &medium\n                    width: var(--input-number-width-medium) !important\n                &large\n                    width: var(--input-number-width-large) !important\n\n        .v-component-container\n            width: fit-content\n            display: flex\n            align-items: center\n            background: var(--input-number-background)\n            border-radius: var(--input-number-border-radius)\n            &.prefixed\n                input\n                    border-top-left-radius: var(--input-number-border-top-left-radius)\n                    border-bottom-left-radius: var(--input-number-border-bottom-left-radius)\n            &.suffixed\n                input\n                    border-top-right-radius: var(--input-number-border-top-right-radius)\n                    border-bottom-right-radius: var(--input-number-border-bottom-right-radius)\n        .input-wrapper\n            position: relative\n            display: flex\n            align-items: center\n        .affix\n            padding: var(--input-number-padding)\n            text-wrap: nowrap\n            user-select: none\n        .clear-icon\n            position: absolute\n            right: 0.75rem\n            cursor: pointer\n            color: var(--gc-text-color-secondary, currentColor)\n            &:hover\n                color: var(--gc-text-color, currentColor)\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
